import StudentInformation from "./01.StudentInformation";
import StudentLocation from "./02.StudentLocation";
import StudentTiming from "./03.StudentTiming";

const Components = {
  StudentInformation,
  StudentLocation,
  StudentTiming,
};

export default Components;
